import { queryOptions, skipToken, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { responseScheme } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

const groupQrCodeResponseScheme = responseScheme.extend({
  GroupQRCode: z.string().url(),
});

type GroupQrCodeResponse = z.infer<typeof groupQrCodeResponseScheme>;

export const generateGroupQrCodeQueryOptions = (groupId: number | null | undefined) =>
  queryOptions({
    queryKey: ['/GetGroupQRCode', groupId],
    queryFn: groupId
      ? ({ signal }) =>
          fetcher<GroupQrCodeResponse>(
            '/GetGroupQRCode',
            { GroupId: groupId },
            {
              signal,
              schema: groupQrCodeResponseScheme,
              validResponseCodes: [0],
            },
          ).then((response) => response?.GroupQRCode ?? null)
      : skipToken,
    refetchOnWindowFocus: false,
  });

export default function useGroupQrCode(groupId: number | null | undefined) {
  return useQuery(generateGroupQrCodeQueryOptions(groupId));
}
